import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { css } from "@emotion/react";
import { MUTATION_TYPE, useToast } from "hooks";
import { UPDATE_INTERVIEW, ADD_INTERVIEW } from "graphql/mutations";
import { GET_INTERVIEW_CATEGORIES } from "graphql/queries";
import { ModalForm } from "components/Modal";
import { SIZE, TYPE } from "components/Form";

/**
 * InterviewEditModal
 *
 * @param {Object}    interview
 * @param {Boolean}   show
 * @param {Function}  onClose
 * @param {Function}  refetchQueries
 */
const InterviewEditModal = ({ interview, show, onClose, refetchQueries = [], ...props }) => {
  const { toast } = useToast();

  const isEditMode = Boolean(interview?.id);

  const handleCompleted = () => {
    onClose();
    toast.success(<FormattedMessage id={`VideoPresentation.Interview${isEditMode ? "Edit" : "Add"}Modal.Success`} />);
  };

  const handleError = () => {
    toast.error(<FormattedMessage id={`VideoPresentation.Interview${isEditMode ? "Edit" : "Add"}Modal.Error`} />);
  };

  return (
    <ModalForm
      title={<FormattedMessage id={`VideoPresentation.Interview${isEditMode ? "Edit" : "Add"}Modal.Title`} />}
      show={show}
      onClose={onClose}
      data={COLUMN_DATA}
      initialValues={{
        name: interview?.name,
        categories: interview?.categories.map((item) => ({
          name: item.name,
          id: item.id,
        })),
      }}
      updateId={interview?.id}
      mutationType={isEditMode ? MUTATION_TYPE.update : MUTATION_TYPE.add}
      mutationData={{
        mutationName: {
          update: UPDATE_INTERVIEW,
          add: ADD_INTERVIEW,
        },
        refetchAfterMutate: refetchQueries.length > 0,
        refetchQueries,
      }}
      onCompleted={handleCompleted}
      onError={handleError}
      {...props}
    />
  );
};

const COLUMN_DATA = [
  {
    style: css`
      width: 100%;
    `,
    items: [
      {
        label: "Title",
        type: TYPE.input,
        size: SIZE.xlarge,
        properties: {
          name: "name",
          type: "text",
          required: true,
          autoFocus: true,
        },
      },
      {
        label: "Categories",
        type: TYPE.tags,
        size: SIZE.xlarge,
        properties: {
          name: "categories",
          placeholder: "Select category",
          required: false,
          queryName: GET_INTERVIEW_CATEGORIES,
          queryKeyName: "interviewCategories",
          minLength: 0,
        },
      },
    ],
  },
];

InterviewEditModal.propTypes = {
  interview: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  refetchQueries: PropTypes.array,
};

export default InterviewEditModal;
